import { Pipe, PipeTransform } from '@angular/core';
import { ICreateAccount } from "../../../../../../shared/account/create-account.helper";

@Pipe({
  name: 'appNotificationsInnerSearch'
})
export class NotificationsInnerSearchPipe implements PipeTransform {
  public transform(value: ICreateAccount[] | null, term: string) {
    value = value || [];
    if (!term) return value;
    return (value || [])
      .filter(item =>
        new RegExp(term, 'gi').test(item.name)
        || new RegExp(term, 'gi').test(item.domain)
      );

  }
}
